<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="onSubmit" ref="machine_class_form">
        <div class="form-group">
          <label>Nome</label>
          <input
            type="text"
            v-model="machine_class.name"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label>Descrição</label>
          <textarea
            v-model="machine_class.description"
            class="form-control"
          ></textarea>
        </div>

        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="machine_class.active"
              :value="1"
              id="active"
              aria-describedby="active_checkbox_help_text"
            />
            <label class="form-check-label" for="active"> Ativo </label>
            <small id="active_checkbox_help_text" class="form-text text-muted">
              Ao deixar desmarcado, este tipo de equipamento não aparecerá no
              formulário de cadastro de máquinas.
            </small>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6">
            <button class="btn btn-default" type="button" @click="openTable()">{{'<<'}} Voltar para a listagem</button>
          </div>
          <div class="col-6 d-flex flex-row-reverse">
            <button class="btn btn-dark">
              <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
              {{ submit_text }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import useMachineClass from '@/modules/MachineClass.js'
  import { ref, onMounted } from 'vue'

  import { useRoute, useRouter } from 'vue-router'

  export default {
    setup() {
      const route = useRoute()
      const router = useRouter()

      const loading = ref(true)
      const machine_class_form = ref(null)

      const machine_class = ref({
        name: '',
        description: '',
        active: '',
      })

      const submit_text = ref('')

      const { getMachineClass, saveMachineClass, listMachineClasses } =
        useMachineClass()

      const onSubmit = () => {
        saveMachineClass(machine_class.value)
          .then(() => {
            listMachineClasses(1, 10)
            router.push('/machine-classes')
          })
          .catch(() => {})
      }

      onMounted(async () => {
        if (route.params.id) {
          await getMachineClass(route.params.id).then((response) => {
            machine_class.value = response.data.data
          })

          submit_text.value = 'Salvar alterações'
        } else {
          submit_text.value = 'Cadastrar'
        }

        loading.value = false
      })

      return {
        machine_class,
        machine_class_form,
        onSubmit,
        router
      }
    },
    methods: {
      openTable() {
        this.router.push('/machine-classes');
      }
    }

  }
</script>
